<form [formGroup]="createWebsiteForm" (ngSubmit)="submit()">
  <!-- submit form with Enter -->
  <button [disabled]="loading" type="submit" style="display:none">hidden submit</button>

  <div *ngIf="createWebsiteMode === 'multisite'"
       class="db-website-install__multisite mb30">
    <p class="ds-radio-label">{{ 'text_installMultisiteType' | dbText }}</p>
    <div class="db-website-install__multisite-types">
      <div *ngFor="let type of multisiteTypes">
        <input class="ds-radio" type="radio" [id]="type.value" [value]="type.value" formControlName="multisiteType">
        <label [for]="type.value" [innerHTML]="type.slug"></label>
      </div>
    </div>
  </div>

  <div class="ds-input-wrap static mb28">
    <span class="ds-input-label">{{ 'text_siteTitle' | dbText }}</span>
    <input type="text" class="ds-input" [class.error]="formSubmitted && createWebsiteForm?.get('websiteTitle')?.errors"
           [placeholder]="'text_wordpressInstallationSiteTitlePlaceholder' | dbText" maxlength="255" formControlName="websiteTitle">
    <span *ngIf="formSubmitted && createWebsiteForm?.get('websiteTitle')?.errors" class="ds-input-error-msg"
          [innerHTML]="createWebsiteForm?.get('websiteTitle')?.errors['required'] ?
            ('text_fillFnField' | dbText) : ''"></span>
  </div>

  <div class="ds-input-wrap alo static mb28">
    <ds-dropdown [dsDropdownOptions]="regions" formControlName="region"
                 [dsDropdownDisabled]="userSubscription?.type === UserSubscriptionCategory.DedicatedVM"
                 [dsDropdownLabel]="('text_regionDescription' | dbText)"></ds-dropdown>
  </div>

  <div class="ds-input-wrap static mb28">
    <span class="ds-input-label">{{ 'text_installWebsiteDialogTitle' | dbText }}</span>
    <div class="db-website-install__subdomain">
      <input type="text" class="ds-input mr20" maxlength="56"
             [class.error]="formSubmitted && createWebsiteForm?.get('subdomain')?.errors"
             [placeholder]="'text_subdomainPlaceholder' | dbText" formControlName="subdomain">
      <span class="db-domain-link"
            [dsTooltip]="'.'+configHostname"
            [dsTooltipColor]="'black'"
            [hostClass]="'cover-all'"
            [dsTooltipAlign]="'left'"
            [dsTooltipPosition]="'top'"
            [dsTooltipSize]="'small'"
            [dsTooltipVisible]="shouldShowHostnameTooltip">
          .{{configHostname}}</span>
    </div>
    <span *ngIf="formSubmitted && createWebsiteForm?.get('subdomain')?.errors" class="ds-input-error-msg"
          [innerHTML]="createWebsiteForm?.get('subdomain')?.errors['required'] ?
            ('text_fillFnField' | dbText):
            createWebsiteForm?.get('subdomain')?.errors?.pattern ? ('text_fillFieldAllowedLetters' | dbText) :
            createWebsiteForm?.get('subdomain')?.errors?.taken ? createWebsiteForm?.get('subdomain')?.errors?.taken
            : ''"></span>
    <span class="ds-input-desc">{{ 'text_subDomainDescription' | dbText }}</span>

  </div>

  <div *ngIf="showDomainField" class="db-domain-input-wrap ds-input-wrap static">
    <span class="ds-input-label">{{ 'text_domainWithTitle' | dbText }}</span>
    <input type="text" class="ds-input" [class.error]="formSubmitted && createWebsiteForm?.get('domain')?.errors"
           maxlength="249" [placeholder]="'text_domainPlaceholder' | dbText" formControlName="domain">
    <span *ngIf="formSubmitted && createWebsiteForm?.get('domain')?.errors" class="ds-input-error-msg"
          [innerHTML]="createWebsiteForm?.get('domain')?.errors?.server ?
            createWebsiteForm?.get('domain')?.errors?.server : ''"></span>
    <span *ngIf="false" class="ds-input-error-msg">error</span>
<!--
    <span class="ds-input-desc">Don’t have a domain? <a class="link" (click)="sendEvent('Get a new custom domain under input')" target="_blank" [routerLink]="'domains-handler/search'">Get a new custom domain</a></span>
-->
  </div>

  <div class="domains-wrap">
   <!-- <a *ngIf="!showDomainField" class="db-website-install__link external" target="_blank" (click)="sendEvent('Get a new custom domain button')" [routerLink]="'domains-handler/search'"><span>Get a new custom domain</span><i class="db-icon db-icon-ds-arrow-link"></i></a>-->
    <a *ngIf="!showDomainField" class="db-website-install__link"
       (click)="showDomain()">{{ 'text_iHaveADomain' | dbText }}</a>
  </div>


  <hr class="db-website-install__separator mt30 mb30">

  <div class="db-website-install__section">
    <h4>{{ 'text_wpAdminCredentials' | dbText }}</h4>

    <div class="ds-input-wrap static mb28">
      <span class="ds-input-label">{{'text_adminUsername' | dbText}}</span>
      <input class="ds-input" [class.error]="formSubmitted && createWebsiteForm?.get('userName')?.errors"
             maxlength="60" [placeholder]="'text_usernamePlaceholder' | dbText" formControlName="userName">
      <span *ngIf="formSubmitted && createWebsiteForm?.get('userName')?.errors" class="ds-input-error-msg"
            [innerHTML]="createWebsiteForm?.get('userName')?.errors['required'] ? 'This field is required.' : ''">
        </span>
    </div>

    <div class="ds-input-wrap static">
      <span class="ds-input-label">{{'text_adminPassword' | dbText}}</span>
      <div class="password-wrap">
        <div class="ds-input-password-wrap">
          <input class="ds-input" [class.error]="formSubmitted && createWebsiteForm?.get('password')?.errors"
                 #password type="password" maxlength="63"
                 [placeholder]="'text_createProfilePassword' | dbText" formControlName="password">
          <a class="ds-input-password-trigger copy" ngxClipboard [cbContent]="password.value" *ngIf="password.value">
            <i class="db-icon db-icon-copy"></i>
          </a>
          <a class="ds-input-password-trigger"
             (click)="password.type = password.type === 'text' ? 'password' : 'text'; password.focus()">
            <i class="db-icon {{password.type === 'text' ? 'db-icon-ds-eye' : 'db-icon-ds-eye-cancel'}}"></i>
          </a>
        </div>
        <button class="ds-btn ml20 ds-hide-mobile" [disabled]="loading"
                type="button" (click)="generateRandomPassword()">
          <span>{{'text_generateButton' | dbText}}</span>
        </button>
        <button class="ds-btn ds-btn-icon ml20 ds-hide-desktop" [disabled]="loading"
                type="button" (click)="generateRandomPassword()">
          <span><i class="db-icon db-icon-ds-switch"></i></span>
        </button>
      </div>
      <span *ngIf="formSubmitted && createWebsiteForm?.get('password')?.errors" class="ds-input-error-msg"
            [innerHTML]="createWebsiteForm?.get('password')?.errors['required'] ? ('text_fillFnField' | dbText)
          : createWebsiteForm?.get('password')?.errors?.pattern ? ('text_fillRequiredStrongPasswordField' | dbText) : ''"></span>
      <span class="ds-input-desc">{{'text_wordpressPasswordGenerateDescription' | dbText}}</span>
    </div>
  </div>

</form>
